import { jsx as _jsx } from "react/jsx-runtime";
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import * as React from 'react';
import { Link } from '../link';
export const BreadcrumbLink = (props) => {
    return (_jsx(Link, { href: props.href, "aria-current": props['aria-current'], color: "text.secondary", noWrap: true, underline: "hover", textTransform: "sentence", children: props.children }));
};
export const Breadcrumbs = (props) => {
    if (!props.items.length) {
        return null;
    }
    return (_jsx(MuiBreadcrumbs, { "aria-label": "breadcrumb", children: props.items.map(({ href, children, ...linkProps }, index) => (_jsx(BreadcrumbLink, { href: href, "aria-current": index === props.items.length - 1 ? 'page' : undefined, ...linkProps, children: children }, href))) }));
};
export const breadcrumbsStyle = {
    MuiBreadcrumbs: {
        styleOverrides: {
            ol: { flexWrap: 'nowrap' }
        }
    }
};
